import React, { FC, useEffect, Fragment } from 'react'
import { useParams } from 'react-router-dom'
import { AreaTools, AreaSelection } from 'models/editor'
import { Icon } from 'components/Icon'
import { useTranslation } from 'react-i18next'
import { useMapEditorContext, MapEditorWizards } from 'context/map-editor-context'
import { Tooltip } from 'components/Tooltip'
import { useFetchOrganization } from 'services/organization'

type mapToolsProps = {
  onPinPointClick: () => any
  isPinpointActive: any
}

export const DrawingTools: FC<mapToolsProps> = (
   /* _props */ { onPinPointClick, isPinpointActive },
) => {
  const { t } = useTranslation()
  const { projectId } = useParams()
  const [{ areaTool, wizard }, mapEditorDispatch] = useMapEditorContext()
  const { organization } = useFetchOrganization()

  useEffect(() => {
    const onKeyDown = (event: any) => {
      if (event.code === 'Escape') {
        mapEditorDispatch.cancelWizard()
      }
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  })

  const toolIsActive = (tool: AreaSelection) => {
    return (
      tool === areaTool &&
      wizard &&
      [MapEditorWizards.PROJECT_CREATE, MapEditorWizards.CHANGE_PROJECT_AREA].includes(wizard)
    )
  }

  const onToolClick = (tool: AreaTools) => {
    mapEditorDispatch.selectTool(tool)
    if (
      tool === AreaTools.POINT ||
      tool === AreaTools.POLYGON ||
      tool === AreaTools.REGION ||
      tool === AreaTools.RADIUS ||
      tool === AreaTools.FILE_UPLOAD ||
      tool === AreaTools.POINT_PONDERA
    ) {
      if (String(wizard) !== 'COMPARE_AREA') {
        projectId
          ? mapEditorDispatch.setWizard(MapEditorWizards.CHANGE_PROJECT_AREA)
          : mapEditorDispatch.setWizard(MapEditorWizards.PROJECT_CREATE)
      }
    }
  }

  const onToolClick2 = () => {
    if (!isPinpointActive) {
      mapEditorDispatch.selectTool(AreaTools.POINT2)
    } else {
      mapEditorDispatch.selectTool(AreaTools.POINT3)
    }
  }

  return (
    <Fragment>
      <button
        onClick={() => { onPinPointClick(); onToolClick2() }}
        data-selected={isPinpointActive}
        aria-label={t('map.tools.drawing.point')}
      >
        <Tooltip label={t(`tooltips.maptools.proyecto_isocrona_radio2`)} direction="LEFT_CENTER">
          <Icon name="map-pin-5-line" />
        </Tooltip>
      </button>
      <button
        onClick={() => onToolClick(AreaTools.POINT)}
        data-selected={toolIsActive(AreaTools.POINT) ? true : undefined}
        aria-label={t('map.tools.drawing.point')}
      >
        <Tooltip label={t(`tooltips.maptools.proyecto_isocrona_radio`)} direction="LEFT_CENTER">
          <Icon name="map-pin-line" />
        </Tooltip>
      </button>
      <button
        onClick={() => onToolClick(AreaTools.POLYGON)}
        data-selected={toolIsActive(AreaTools.POLYGON) ? true : undefined}
        aria-label={t('map.tools.drawing.polygon')}
      >
        <Tooltip label={t(`tooltips.maptools.proyecto_poligono`)} direction="LEFT_CENTER">
          <Icon name="shape-fill" />
        </Tooltip>
      </button>
      <button
        onClick={() => onToolClick(AreaTools.REGION)}
        data-selected={toolIsActive(AreaTools.REGION) ? true : undefined}
        aria-label={t('map.tools.drawing.region')}
      //disabled={wizard === MapEditorWizards.COMPARE_AREA}
      >
        <Tooltip label={t(`tooltips.maptools.proyecto_territorio`)} direction="LEFT_CENTER">
          <Icon name="globe-line" />
        </Tooltip>
      </button>
      <button
        onClick={() => onToolClick(AreaTools.RADIUS)}
        data-selected={toolIsActive(AreaTools.RADIUS) ? true : undefined}
        aria-label={t('map.tools.drawing.radius')}
      >
        <Tooltip label={t(`tooltips.maptools.proyecto_radio`)} direction="LEFT_CENTER">
          <Icon name="compass-2-line" />
        </Tooltip>
      </button>
      <button
        onClick={() => onToolClick(AreaTools.FILE_UPLOAD)}
        data-selected={toolIsActive(AreaTools.FILE_UPLOAD) ? true : undefined}
        aria-label={t('map.tools.drawing.file_upload')}
      >
        <Tooltip label={t(`tooltips.maptools.proyecto_tus_geometrias`)} direction="LEFT_CENTER">
          <Icon name="file-upload-line" />
        </Tooltip>
      </button>
      {organization?.ponderaReport === true && (
        <button
          onClick={() => onToolClick(AreaTools.POINT_PONDERA)}
          data-selected={toolIsActive(AreaTools.POINT_PONDERA) ? true : undefined}
          aria-label={t('map.tools.drawing.file_upload')}
        >
          <Tooltip label={t('create_project.pondera_dialog.title')} direction="LEFT_CENTER">
            <Icon name="coins-line" />
          </Tooltip>
        </button>
      )}
    </Fragment>
  )
}

DrawingTools.displayName = 'DrawingTools'
